// @flow

import _ from 'lodash';

import ApiObject from '../ApiObject';
import DateUtils from '../../utils/DateUtils';

import AvailabilityHour from './AvailabilityHour';

export default class AvailabilityHoursForDay extends ApiObject {

  hours: Array<AvailabilityHour> = [];

  postJsonAssignation(data: Object) {
    this.hours = [];

    // change to data.hours if api change. See toJSON comment
    _.each(!_.isNil(data.hours) ? data.hours : data, (availabilityHourData: Object) => {
      const availabilityHour = new AvailabilityHour().fromJson(availabilityHourData);
      this.hours.push(availabilityHour);
    });
  }

  toJSON() {
    // For now we use a sub object AvailabilityHoursForDay but the api does not have similar object,
    // it expects directly an array of AvailabilityHour.
    const json = super.toJSON();
    return json['hours'];
  }

  setHours(hours: Array<AvailabilityHour>) {
    this.hours = hours;
  }

  addHour(hours: AvailabilityHour) {
    this.hours.push(hours);
  }

  deleteHour(toRemove: AvailabilityHour) {
    let res = [];

    res = this.hours.filter((availabilityHour) => {
      return !_.isEqual(availabilityHour, toRemove)
    })

    this.hours = res;

    if (_.isEmpty(this.hours)) {
      this.setAvailableOnDay()
    }
  }

  resetHours() {
    this.hours = []
  }

  haveAvailibility(): boolean {
    return !_.isEmpty(this.hours) || this.isAvailableForWholeDay();
  }

  isAvailableForDate(date: Moment) {
    const slot: Hour = DateUtils.getTimestampForHourWithDate(date);

    let res = false;
    _.each(this.hours, (hour: Hour) => {
      if (hour.opening <= slot && hour.closing >= slot) {
        res = true;
        return false; // quit loop
      }
    });

    return res;
  }

  isAvailableForWholeDay(): boolean {
    let res = false;

    _.each(this.hours, (hour) => {
      if (hour.isWholeDay()) {
        res = true;
        return false; // quit loop
      }
    });

    return res;
  }

  setAvailableForWholeDay() {
    this.hours = [];
    const hour = new AvailabilityHour();
    hour.setToWholeDay();
    this.hours.push(hour);
  }

  setAvailableOnDay() {
    this.hours = [];
    const hour = new AvailabilityHour();
    hour.setAvailableOnDay();
    this.hours.push(hour);
  }

  setNotAvailableForWholeDay() {
    this.hours = [];
  }

  isDisable() {
    return !this.isAvailableForWholeDay() && _.isEmpty(this.hours);
  }

  isEnable() {
    return !this.isDisable();
  }

  disable() {
    this.setNotAvailableForWholeDay();
    // this.hours = [];
  }
}
